module.exports = __webpack_public_path__ + "static/media/protect.4c3b6cc6.svg";